import { BankAccountTimelineEvent } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/bankAccountTimeline.types.ts';
import { TimelineAuditCard } from '@dealstack/frontend/shared/components/Audit/AuditLayout/AuditCard.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Stack, Text } from '@mantine/core';

interface Props {
	events: BankAccountTimelineEvent[];
	isLoading: boolean;
	selectedEventId?: string;
	onSelectEvent: (eventId: string) => void;
}

/** What has happened to this account, newest first, named by the event rather than by the
 *  table write behind it. Selecting an entry opens its diff in the main region. */
export const HistoryTab = ({ events, isLoading, selectedEventId, onSelectEvent }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (isLoading) {
		return (
			<Flex pos="relative" h="100%" p="1.5rem">
				<InlineLoader />
			</Flex>
		);
	}

	return (
		<Flex direction="column" gap="1rem" p="1rem">
			<Text fz={18} fw={600} c="dark.8">
				{tMipManage('bank_accounts.details.history.title', {
					defaultValue: 'Timeline events',
				})}
			</Text>

			{events.length === 0 ? (
				<Text size="sm" c="dark.0">
					{tMipManage('bank_accounts.details.history.empty', {
						defaultValue: 'No activity recorded for this account yet.',
					})}
				</Text>
			) : (
				<Stack gap="1.25rem">
					{events.map((event, index) => (
						<TimelineAuditCard
							key={event.audit.id}
							audit={event.audit}
							title={tMipManage(event.translationKey, {
								defaultValue: event.defaultValue,
							})}
							isSelected={event.audit.id === selectedEventId}
							onCardClick={onSelectEvent}
							showTableName={false}
							singleRow
							iconSize="lg"
							showDivider={index !== events.length - 1}
						/>
					))}
				</Stack>
			)}
		</Flex>
	);
};
